import React from "react";
import { useEffect, useState } from "react";
import { Table } from "antd";
import LiveQualitiesForm from "./LiveQualitiesForm.jsx";
import chevron from "assets/images/fabricQualities/chevron.svg";

import { columnsData, initialValues, transformToForm } from "./base";
import style from "../TopQualities/style.module.scss";
import {
  getMaterialData
} from "store/actions/FabricQualitiesActions.js";
import { connect } from "react-redux";
import { getLiveRatesData, updateLiveQuality } from "store/actions/LiveRates.js";

const LiveQualities = ({
  getMaterialDataApi,
  getTableData,
  updateLiveQualityData,
  tableData,
  disabledTableData,
  materialData,
}) => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [formData, setFormData] = useState({ ...initialValues });
  const [isUpdate, setIsUpdate] = useState(false);
  const [page, setPage] = useState(1);
  const [disabledPage, setDisabledPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const DEFAULT_DATA_LIMIT = 5;

  const reloader = () => {
    setLoader(!loader);
  };
  useEffect(() => {
    getMaterialDataApi();
  }, []);

  useEffect(() => {
    let params = {
      pageNumber: page,
      limit: DEFAULT_DATA_LIMIT,
      isDisabled: 0,
    };
    getTableData(params);
  }, [page, loader]);

  useEffect(() => {
    let params = {
      pageNumber: disabledPage,
      limit: DEFAULT_DATA_LIMIT,
      isDisabled: 1,
    };
    getTableData(params);
  }, [disabledPage, loader]);

  const edit = (record) => {
    const form = transformToForm(record);
    setFormData(form);
    setIsUpdate(true);
    setIsFormVisible(true);
  };

  return (
    <div className={style.page}>
      <div className={style.head}>
        <div className={style.headline}>Live rates</div>
        <button
          className="btn btn--blue-bg"
          onClick={() => {
            setFormData({ ...initialValues });
            setIsUpdate(false);
            setIsFormVisible(true);
          }}
        >
          Add qualities
        </button>
      </div>
      <div>
        <Table
          columns={columnsData(materialData, edit, reloader, updateLiveQualityData)}
          dataSource={tableData.records}
          pagination={{
            position: "bottom",
            defaultPageSize: DEFAULT_DATA_LIMIT,
            total: tableData?.paginate?.totalRecords,
            size: "small",
            showSizeChanger: false,
            onChange: (page) => {
              setPage(Number(page));
            },
          }}
          title={() => {
            return <div className={style.tableHeading}>Qualities</div>;
          }}
        />
      </div>
      <div
        className={style.tableHeading}
        style={{ paddingBottom: "20px", paddingTop: "20px" }}
      >
        Disabled qualities
        <img
          src={chevron}
          alt="disabled qualities"
          className={style.chevron}
          onClick={() => setIsTable(!isTable)}
          style={{ transform: !isTable ? "rotate(180deg)" : null }}
        />
      </div>
      {isTable && (
        <div>
          <Table
            columns={columnsData(materialData, edit, reloader, updateLiveQualityData)}
            dataSource={disabledTableData.records}
            pagination={{
              position: "bottom",
              defaultPageSize: DEFAULT_DATA_LIMIT,
              total: disabledTableData?.paginate?.totalRecords,
              size: "small",
              showSizeChanger: false,
              onChange: (page) => {
                setDisabledPage(Number(page));
              },
            }}
            className={style.disabled}
          />
        </div>
      )}
      <div>
        <LiveQualitiesForm
          isUpdate={isUpdate}
          initialFormData={formData}
          visible={isFormVisible}
          onClose={() => {
            setIsFormVisible(false);
          }}
          reload={reloader}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  tableData: state.liveQualities.liveRatesData,
  disabledTableData: state.liveQualities.disabledLiveRatesData,
  materialData: state.fabricQualities.materialData,
});

const mapDispatchToProps = (dispatch) => ({
  getMaterialDataApi: () => dispatch(getMaterialData()),
  getTableData: (data) => dispatch(getLiveRatesData(data)),
  updateLiveQualityData: (data) => dispatch(updateLiveQuality(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveQualities);
